import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className="bg-blue-800 text-white shadow-lg">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold">LORIE Connect</h1>
          <span className="ml-2 text-sm bg-blue-600 px-2 py-1 rounded-full">Tournées</span>
        </div>
        
        <nav className="hidden md:block">
          <ul className="flex space-x-6">
            <li><Link to="/" className="hover:text-blue-300 transition-colors">Tableau de bord</Link></li>
            <li><Link to="/map" className="hover:text-blue-300 transition-colors">Carte en direct</Link></li>
            <li><Link to="/admin" className="hover:text-blue-300 transition-colors">Administration</Link></li>
          </ul>
        </nav>
        
        <div className="flex items-center space-x-4">
          <div className="relative">
            <span className="absolute top-0 right-0 h-3 w-3 bg-red-500 rounded-full"></span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </div>
          
          <div className="flex items-center">
            <img src="https://randomuser.me/api/portraits/women/4.jpg" alt="Avatar" className="h-8 w-8 rounded-full border-2 border-white" />
            <span className="ml-2 hidden md:inline">Marie Lambert</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
